@if (notice(); as notice) {
  <div
    cdkDrag
    cdkDragPreviewClass="shadow-xl"
    [class.hover:bg-gray-50]="!orderMode()"
    class="flex w-full justify-between items-center p-5 border bg-white border-gray-100 rounded-xl transition-colors"
  >
    <div class="flex flex-col gap-3">
      <div class="flex items-center gap-2">
        @if (!invisibleBadge()) {
          @switch (notice.status) {
            @case ('PENDING') {
              <app-badge variant="outline" color="orange">대기</app-badge>
            }
            @case ('ISSUED') {
              <app-badge variant="outline" color="primary">노출</app-badge>
            }
            @case ('EXPIRED') {
              <app-badge variant="outline" color="gray">마감</app-badge>
            }
          }
        }
        @if (notice.isPinned) {
          <app-icon name="ic:round-push-pin" size="sm" class="text-primary" />
        }
        <p class="font-semibold text-gray-800">
          {{ notice.title }}
        </p>
      </div>
      <div class="flex flex-wrap items-center gap-3">
        <div class="*:text-gray-500 *:text-sm flex items-center gap-3">
          <p>발행/마감일</p>
          <p>
            {{ notice.issuedAt | date: 'y-MM-dd HH:mm' }}
            @if (notice.expiredAt) {
              ~ {{ notice.expiredAt | date: 'y-MM-dd HH:mm' }}
            }
          </p>
        </div>
        <div class="h-3 w-px bg-gray-300"></div>
        <div class="*:text-gray-500 *:text-sm flex items-center gap-3">
          <p>작성자</p>
          <p>{{ notice.author }}</p>
        </div>
        <div class="h-3 w-px bg-gray-300"></div>
        <div class="*:text-gray-500 *:text-sm flex items-center gap-3">
          <p>등록일</p>
          <p>
            {{ notice.createdAt | date: 'y-MM-dd HH:mm' }}
          </p>
        </div>
      </div>
    </div>
    <div
      cdkDragHandle
      [ngClass]="
        orderMode() ? 'cursor-move visible' : 'cursor-default invisible'
      "
      class="rounded-full border border-gray-100 bg-gray-50 size-8 flex items-center justify-center"
    >
      <app-icon
        name="material-symbols:menu-rounded"
        class="!size-5 text-gray-400"
      />
    </div>
  </div>
}
